import {    getFirestore,
            doc,
            setDoc, 
            getDoc,
            addDoc,
            getDocs,
            onSnapshot,
            collection} from "firebase/firestore";

import { db } from "./firestoreModel";
import { updateNotes } from "../store/noteboardSlice";

let noteboardUnsubscribers = []

/**
 * Save a clubs notes to firebase
 */
export function saveNotes(clubId, clubNotes){
    const noteboardDoc = doc(db, "noteboard", String(clubId))

    setDoc(noteboardDoc, {
       clubNotes
    }, {merge: true})
}

/**
 * Starts listen to changes in the clubs noteboard doc in firebase. 
 */
export function userClubsNoteboardListner(userClubs, dispatch){
    noteboardUnsubscribers.forEach(unsub => unsub());
    noteboardUnsubscribers = [];
    
    userClubs.forEach(clubId => {
        const noteboardDoc = doc(db, "noteboard", String(clubId))
        
        const unsub = onSnapshot(noteboardDoc, (snapshot) =>{
            const data = snapshot.exists() ? snapshot.data() : undefined;
            const notesArray = Array.isArray(data?.clubNotes) ? data.clubNotes : [];
            console.log("data from firebase", notesArray )
            dispatch(updateNotes({clubId: clubId, notes: notesArray}))
        },
        (error) => {console.error(error)})

        noteboardUnsubscribers.push(unsub)
    })

}